{
  "types": {
    "percentage": "% off",
    "fixed": "¥ off",
    "free_shipping": "Free shipping",
    "bxgy": "Buy some, get one free"
  },
  "types_help": {
    "percentage": "e.g. 10% off the cards",
    "fixed": "e.g. ¥500 off the order",
    "free_shipping": "The customer pays no postage",
    "later": "Comes later"
  },
  "value": {
    "percent": "{{percent}}% off",
    "amount": "{{amount}} off"
  },
  "channels": {
    "web": "Website",
    "pos": "Shop counter"
  },
  "state": {
    "active": "Can be used",
    "scheduled": "Not started yet",
    "expired": "Ended",
    "used_up": "Used up",
    "inactive": "Switched off"
  },
  "columns": {
    "code": "Code",
    "value": "Gives",
    "channels": "Where",
    "period": "When",
    "used": "Used",
    "state": "State"
  },
  "period": {
    "now": "Now",
    "no_end": "no end",
    "always": "Always"
  },
  "used": {
    "of": "{{used}} of {{limit}}",
    "count_one": "{{count}} time",
    "count_other": "{{count}} times"
  },
  "filters": {
    "q": "Search",
    "q_placeholder": "Code or name",
    "active": "Switched on",
    "type": "Kind"
  },
  "list": {
    "intro": "Codes customers type at checkout or tell at the counter. Consigned cards get a discount only where the consignor allows it (at most 10%).",
    "create": "New code"
  },
  "usage": {
    "title": "Where it was used",
    "count": "Used",
    "total": "Discount given in total:",
    "none": "Not used yet."
  },
  "locales": {
    "en": "English",
    "ja": "日本語",
    "th": "ไทย",
    "zh_Hant": "繁體中文",
    "zh_Hans": "简体中文"
  },
  "product_types": {
    "raw_single": "Single cards",
    "graded_single": "Graded cards",
    "sealed_product": "Sealed boxes / packs"
  },
  "problems": {
    "code": "3–64 letters or numbers (and - _), starting with a letter or number.",
    "percent": "Type a percentage between 0 and 100.",
    "amount": "Type the amount in whole yen.",
    "collections": "Choose at least one collection.",
    "types": "Choose at least one kind of product.",
    "channels": "Choose the website, the counter or both.",
    "count": "A whole number, or empty for no limit.",
    "period": "The end must be after the start.",
    "fix_one": "Fix {{count}} box first.",
    "fix_other": "Fix {{count}} boxes first."
  },
  "form": {
    "load_failed": "The code could not be opened",
    "back": "All codes",
    "new_title": "New discount code",
    "tabs": "Code",
    "tab_settings": "Settings",
    "tab_usage_one": "Used ({{count}})",
    "tab_usage_other": "Used ({{count}})",
    "kind": "What kind of discount?",
    "code_block": "Code and name",
    "code": "Code the customer types",
    "code_hint": "Capital letters and numbers, e.g. WEEKEND10.",
    "suggest": "Make one",
    "code_locked": "The code was used already — it cannot be renamed.",
    "titles": "Name customers see (optional)",
    "how_much": "How much?",
    "percent": "Percent off",
    "amount": "Amount off",
    "shipping_where": "Free shipping to",
    "shipping": {
      "everywhere": "Every country",
      "japan": "Japan only"
    },
    "applies": "Works on",
    "applies_to": {
      "all": "The whole shop",
      "collections": "Some collections",
      "types": "Some kinds of product"
    },
    "collections_search": "Find a collection",
    "collections_none": "No collection found.",
    "collection_count_one": "{{count}} product",
    "collection_count_other": "{{count}} products",
    "conditions": "Conditions",
    "channels": "Where it works",
    "min_subtotal": "Minimum order",
    "min_subtotal_hint": "Empty = any amount.",
    "usageLimit": "How many times in total",
    "perCustomerLimit": "How many times per customer",
    "limit_hint": "Empty = no limit.",
    "groups_later": "Codes for customer groups come later.",
    "when": "When",
    "this_weekend": "This weekend",
    "startsAt": "From",
    "endsAt": "Until",
    "jst": "Japan time.",
    "consigned": "Consigned cards",
    "respects": "Follow the consignors' choice",
    "respects_help": "Consigned cards get a discount only where the consignor allows it, and at most {{max}}%.",
    "warning": {
      "over_limit": "{{percent}}% is more than {{max}}%: consigned cards get at most {{max}}% (and only where the consignor allows it) — the shop's own cards get {{percent}}%.",
      "ignores_consignor": "Consigned cards would be discounted without asking the consignors. Only do this if every consignor agreed."
    },
    "active": "Switched on (customers can use it)",
    "save": "Save the changes",
    "create": "Make the code",
    "read_only": "Only the owner or a manager can change codes.",
    "saved": "{{code}} saved",
    "created": "{{code}} is ready",
    "stale": "Someone changed this code a moment ago. Open it again.",
    "switch_off": "Switch off",
    "switch_on": "Switch on",
    "switched_off": "{{code}} is switched off",
    "switched_on": "{{code}} is switched on",
    "delete": "Delete",
    "delete_title": "Delete {{code}}?",
    "delete_consequence": "The code is gone. Customers cannot use it any more.",
    "delete_used": "This code was used already — it stays in the history. Switch it off instead.",
    "deleted": "{{code}} deleted",
    "in_use": "This code was used — switch it off instead."
  }
}
